import renameKeys from 'deep-rename-keys'

export default renameKeys
export const renameKeysToCamelCase = obj => (obj ? renameKeys(obj, key => camelCase(key)) : obj)
export const renameKeysToSnakeCase = obj => (obj ? renameKeys(obj, key => snakeCase(key)) : obj)

function camelCase(str) {
  return str ? String(str).replace(/_(.)/g, (_, p1) => p1.toUpperCase()) : str
}

function snakeCase(str) {
  return str ? String(str).replace(/([a-z])([0-9A-Z])/g, (_, p1, p2) => `${p1}_${p2.toLowerCase()}`) : str
}
